import React from 'react';
import { Col, Table } from 'antd';
import { TableProps, TablePaginationConfig } from 'antd/es/table';
import NoDataFound from '../NoDataFound/NoDataFound';
import { colors } from '../../utils/colors/colors';

interface AppTableProps<T extends object> extends Omit<TableProps<T>, 'pagination'> {
    loading: boolean;
    paginationConfig?: TablePaginationConfig;
}

const AppTable = <T extends object>({
    dataSource,
    loading,
    paginationConfig,
    ...restOfProps
}: AppTableProps<T>) => {

    const emptyText = (
        <Col style={{ minHeight: '200px' }}>
            <NoDataFound />
        </Col>
    );

    const defaultPagination: TablePaginationConfig | false = paginationConfig ? {
        position: ['bottomRight'],
        style: { margin: '16px 0', color: colors.blueitNavyBlue, paddingRight: "16px" },
        ...paginationConfig
    } : false;

    return (
        <Table<T>
            className='app-table'
            dataSource={dataSource}
            loading={loading}
            pagination={defaultPagination}
            locale={{ emptyText: emptyText }}
            {...restOfProps}
        />
    );
};

export default AppTable;